<template>
	<div>
		<b-modal
			id="addConfigModal"
			centered
			hide-footer
			hide-header
			v-model="showModal"
			no-close-on-backdrop
			@hidden="resetForm"
			size="lg"
		>
			<header
				class="d-flex align-items-center justify-content-between addcon-border-bottom head"
			>
				<div
					class="font-lato fw-500 fs-18 color-black d-flex align-items-center gap-2 pointer"
				>
					<img
						@click="$emit('close-modal')"
						src="../../assets/common-icons/modal-back-arrow.svg"
						alt=""
					/><span>{{ configType }} Configuration</span>
				</div>
				<div @click="$emit('close-modal')">
					<img
						class="rotate-on-hover pointer"
						src="../../assets/common-icons/blue-cross.svg"
						alt=""
					/>
				</div>
			</header>
			<div class="addcon-tabs-height">
				<b-tabs class="dynamic-modal-tabs" v-model="tabIndex">
					<div
						v-if="
							$v.configData.name.$error ||
								$v.configData.testOrg.$error ||
								$v.configData.testDesc.$error
						"
						style="position: absolute; top: 65px; left: 210px"
						v-b-popover.hover.top.v-danger="{
							content: 'Please fill all the details',
						}"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div
						v-if="checkSecondTabError"
						style="position: absolute; top: 65px; left: 430px"
						v-b-popover.hover.top.v-danger="{
							content: 'Please fill all the details',
						}"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div
						v-if="checkThirdTabError"
						style="position: absolute; top: 65px; left: 645px"
						v-b-popover.hover.top.v-danger="{
							content: 'Please fill all the details',
						}"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div
						v-if="checkFourthTabError"
						style="position: absolute; top: 65px; left: 890px"
						v-b-popover.hover.top.v-danger="{
							content: 'Please fill all the details',
						}"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<b-tab title="Opening Screen Display">
						<div class="addcon-tab-line" style="left: 10px;"></div>
						<div class="addcon-modal-scroll addcon-border-bottom">
							<b-row>
								<b-col cols="4" class="pr-30">
									<InputComponent
										:disabled="disableAll"
										:validation="
											$v.configData.name.$error || !$v.configData.name.maxLength
										"
										title="Configuration Name"
										v-model="configData.name"
										:validationMessage="
											!$v.configData.name.maxLength
												? 'Should not exceed 128 characters'
												: null
										"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<InputComponent
										:disabled="disableAll"
										title="Test Organiser"
										v-model="configData.testOrg"
										:validation="
											$v.configData.testOrg.$error ||
												!$v.configData.testOrg.maxLength
										"
										:validationMessage="
											!$v.configData.testOrg.maxLength
												? 'Should not exceed 128 characters'
												: null
										"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<SingleSelect
										text="Test Type"
										:disabled="true || disableAll"
										isMandatory
										v-model="configData.test"
										:optionsArray="testTypeOptions"
									/>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="12" class="mt-4 pr-30">
									<label>Test Description<span class="asterik">*</span></label>
									<div
										:class="
											($v.configData.testDesc.$error && dirtyCheckdesc) ||
											!$v.configData.testDesc.maxLength
												? 'errorClass-1'
												: ''
										"
									>
										<QuillEditor
											labelTxt="Test Description"
											v-model="configData.testDesc"
											:value="$v.configData.testDesc.$model"
											@validationVal="validateText"
											@questionText="updateTestDesc"
											:designClass="true"
											:disableQuill="disableAll"
										/>
										<div
											style="position: absolute; top: 35px; right: 4vw"
											v-if="
												($v.configData.testDesc.$error &&
													!$v.configData.testDesc.required &&
													dirtyCheckdesc) ||
													!$v.configData.testDesc.maxLength
											"
											v-b-popover.hover.top.v-danger="{
												content: !$v.configData.testDesc.required
													? 'Required'
													: 'Should not exceed 100024 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
						</div>
						<div class="d-flex justify-content-between py-2 px-4">
							<div
								class="font-mont fw-600 fs-14 color-696969 text-underline pointer mt-2"
								@click="loadExistingConfigs"
							>
								Select from existing
							</div>
							<div class="d-flex align-items-center gap-4">
								<b-button class="new-cancelBtn mt-1" @click="cancel"
									>Cancel</b-button
								>
								<b-button class="new-addBtn mt-1" @click="goNext(1)"
									>Next</b-button
								>
							</div>
						</div>
					</b-tab>
					<b-tab title="Question Behaviour">
						<div class="addcon-tab-line" style="left: 244px;"></div>
						<div class="addcon-modal-scroll addcon-border-bottom">
							<b-row>
								<b-col cols="4" class="pr-30">
									<DateField
										text="Start Time"
										:value="configData.openTestdt"
										:datetime-value="configData.openTestdt"
										:isMandatory="true"
										:validation="
											$v.configData.openTestdt.$error || timeDiffMinutes
										"
										@input="(val) => updateDateTime('open', val)"
										:showDateTime="true"
										:placeholder="'Select Start Date & Time'"
										:disabled="disableAll"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<DateField
										text="End Time"
										:value="configData.closeTestdt"
										:datetime-value="configData.closeTestdt"
										:isMandatory="true"
										@input="(val) => updateDateTime('close', val)"
										:validation="
											$v.configData.closeTestdt.$error || timeDiffMinutes
										"
										:showDateTime="true"
										:placeholder="'Select End Date & Time'"
										:disabled="disableAll"
									/>
									<div
										style="position: absolute; top: 35px; right: 58px"
										v-if="timeDiffMinutes || $v.configData.closeTestdt.$error"
										v-b-popover.hover.top.v-danger="{
											content: timeDiffMinutes
												? 'The start and end time & date cannot be less than the test duration.'
												: 'Required',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</b-col>
								<b-col cols="4" class="pr-30">
									<InputComponent
										title="Passing Percentage"
										:valType="'number'"
										v-model="configData.passingPercentage"
										:validation="
											$v.configData.passingPercentage.$error ||
												!$v.configData.passingPercentage.between ||
												!$v.configData.passingPercentage.numeric
										"
										:validationMessage="
											!$v.configData.passingPercentage.between
												? 'Should be between 1 to 100'
												: !$v.configData.passingPercentage.numeric
												? 'Not valid number'
												: null
										"
										:toFixed="true"
										:disabled="disableAll"
									/>
								</b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col cols="4" class="pr-30">
									<InputComponent
										title="Number Of Questions Per Screen"
										:valType="'number'"
										v-model="configData.quesPerScreen"
										:validation="
											$v.configData.quesPerScreen.$error ||
												!$v.configData.quesPerScreen.between ||
												!$v.configData.quesPerScreen.numeric
										"
										:validationMessage="
											!$v.configData.quesPerScreen.between
												? 'Should be between 1 to 100'
												: !$v.configData.quesPerScreen.numeric
												? 'Not valid number'
												: null
										"
										:toFixed="true"
										:disabled="disableAll"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<InputComponent
										title="Test Duration (Minutes"
										:valType="'number'"
										v-model="configData.testDuration"
										:validation="
											$v.configData.testDuration.$error ||
												!$v.configData.testDuration.alpha ||
												!$v.configData.testDuration.between ||
												!$v.configData.testDuration.required
										"
										:validationMessage="
											!$v.configData.testDuration.alpha
												? 'Should not contain special characters'
												: !$v.configData.testDuration.between
												? 'Should be between 5 to 360'
												: null
										"
										:toFixed="true"
										:disabled="disableAll"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<InputComponent
										title="Specify Negative Marks "
										:valType="'number'"
										v-model="configData.negativeMarkValue"
										:validation="
											$v.configData.negativeMarkValue.$error ||
												!$v.configData.negativeMarkValue.numeric ||
												!$v.configData.negativeMarkValue.between
										"
										:validationMessage="
											!$v.configData.negativeMarkValue.numeric
												? 'Not valid number'
												: !$v.configData.negativeMarkValue.between
												? 'Should be between 0 to 30'
												: null
										"
										:toFixed="true"
										:disabled="disableAll"
									/>
								</b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col cols="4" class="pr-30">
									<InputComponent
										title="Maximum Number of Attempts"
										type="number"
										v-model="configData.maxnoattempts"
										@input="changeMaxAttempts"
										:validation="
											$v.configData.maxnoattempts.$error ||
												!$v.configData.maxnoattempts.between ||
												!$v.configData.maxnoattempts.numeric
										"
										:validationMessage="
											!$v.configData.maxnoattempts.numeric
												? 'Enter a valid number'
												: !$v.configData.maxnoattempts.between
												? 'Should be between 1 to 10'
												: null
										"
										:toFixed="true"
										:disabled="disableAll"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<InputComponent
										title="Buffer Time (Minutes)"
										type="number"
										v-model="configData.buffertime"
										:validation="
											$v.configData.buffertime.$error ||
												!$v.configData.buffertime.between ||
												!$v.configData.buffertime.numeric
										"
										:validationMessage="
											!$v.configData.buffertime.between
												? 'Should be between 0 to 60'
												: !$v.configData.buffertime.numeric
												? 'Enter a valid whole number'
												: null
										"
										:toFixed="true"
										:disabled="disableAll"
									/>
								</b-col>
								<b-col cols="4"></b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col cols="4" class="pr-30">
									<SingleSelect
										:disabled="configData.maxnoattempts <= 1 || disableAll"
										text="Time Between Attempts"
										isMandatory
										v-model="configData.timebnsel"
										:validation="
											$v.configData.timebnsel.$error ||
												!$v.configData.timebnsel.required
										"
										:optionsArray="filteredTimeOptions"
									/>
								</b-col>
								<b-col cols="4" class="pr-30">
									<InputComponent
										:disabled="!configData.timebnsel || disableAll"
										:title="`Enter time`"
										:placeholder="`Enter in ${configData.timebnsel.text || ''}`"
										type="number"
										v-model="configData.timebnvalue"
										:validation="
											$v.configData.timebnvalue.$error ||
												!$v.configData.timebnvalue.numeric ||
												!$v.configData.timebnvalue.between
										"
										:validationMessage="
											!$v.configData.timebnvalue.numeric
												? 'Enter a valid number'
												: !$v.configData.timebnvalue.between
												? 'Should be between 1 to 60'
												: null
										"
										:toFixedTotwo="true"
									/>
								</b-col>
								<b-col
									cols="4"
									class="mt-2"
									v-if="configData.maxnoattempts > 1"
								>
									<RadioSelect
										:isMandatory="true"
										text="Priority Attempt"
										v-model="configData.priority"
										:options="priorityOptions"
										:disabled="disableAll"
										:selected="configData.priority"
										@updateData="configData.priority = $event"
									/>
								</b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.shuffle"
										:disabled="disableAll"
									>
										Randomly Shuffle Questions
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.dispReqStatus"
										:disabled="disableAll"
									>
										Display Mandatory Question Icon
									</b-form-checkbox></b-col
								>
							</b-row>
							<b-row class="mt-4">
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.displayReqFirst"
										:disabled="disableAll"
									>
										Display Mandatory Questions First
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.dispMarks"
										:disabled="disableAll"
									>
										Display Marks For Every Question
									</b-form-checkbox></b-col
								>
							</b-row>
						</div>
						<div class="d-flex justify-content-between py-2 px-4">
							<div
								class="font-mont fw-600 fs-14 color-696969 text-underline pointer mt-2"
								@click="loadExistingConfigs"
							>
								Select from existing
							</div>
							<div class="d-flex align-items-center gap-4">
								<b-button class="new-cancelBtn mt-1" @click="cancel"
									>Cancel</b-button
								>
								<b-button class="new-addBtn mt-1" @click="goNext(2)"
									>Next</b-button
								>
							</div>
						</div>
					</b-tab>
					<b-tab title="System Setup">
						<div class="addcon-tab-line" style="left: 480px;"></div>
						<div class="addcon-modal-scroll addcon-border-bottom">
							<b-row>
								<b-col cols="4">
									<b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.communicationTest"
										:disabled="disableAll"
										@change="resetProctoring"
									>
										Communication Test
									</b-form-checkbox>
								</b-col>
								<b-col cols="4">
									<b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.enableProctoring"
										:disabled="disableAll"
										@change="resetProctoring"
									>
										Enable Proctoring
									</b-form-checkbox>
								</b-col>
								<b-col cols="4"></b-col>
							</b-row>
							<b-row class="mt-2 pb-2">
								<b-col cols="4"
									><InputComponent
										title="Communication Test Attempts"
										:valType="'number'"
										v-model="configData.communicationTestAttempts"
										:disabled="!configData.communicationTest || disableAll"
										:validation="
											$v.configData.communicationTestAttempts.$error ||
												!$v.configData.communicationTestAttempts.between ||
												!$v.configData.communicationTestAttempts.numeric
										"
										:validationMessage="
											!$v.configData.communicationTestAttempts.between
												? 'Should be between 1 to 5'
												: !$v.configData.communicationTestAttempts.numeric
												? 'Enter a valid number'
												: null
										"
								/></b-col>
								<b-col cols="4"
									><InputComponent
										title="Set Image Capture Timing-Slot (Seconds)"
										:valType="'number'"
										v-model="configData.screenCapture"
										:disabled="!configData.enableProctoring || disableAll"
										:validation="
											$v.configData.screenCapture.$error ||
												!$v.configData.screenCapture.between ||
												!$v.configData.screenCapture.numeric
										"
										:validationMessage="
											!$v.configData.screenCapture.between
												? 'Should be between 1 to 15'
												: !$v.configData.screenCapture.numeric
												? 'Enter a valid number'
												: null
										"
								/></b-col>
								<b-col
									cols="4"
									class="d-flex align-items-end position-relative"
								>
									<b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.enableCamera"
										@change="
											selectdosanddonts(configData.enableCamera, 'enableCamera')
										"
										:disabled="disableAll"
									>
										Enable Video
									</b-form-checkbox>
									<img
										v-if="
											configData.enableProctoring && !configData.enableCamera
										"
										src="../../assets/deletepopupicon.svg"
										alt=""
										style="position: absolute;    left: 138px;
    bottom: 7px;"
										v-b-popover.hover.top.v-danger="{
											content:
												'Enable Video Recording since proctoring is enabled',
										}"
									/>
								</b-col>
							</b-row>
							<hr class="my-4 mr-5	" />
							<b-row class="pt-2">
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.enableScreenShare"
										:disabled="disableAll"
									>
										Enable Screen Share
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.internetCheck"
										:disabled="disableAll"
									>
										Enable Internet Check
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.typingTest"
										:disabled="disableAll"
									>
										Typing Test
									</b-form-checkbox></b-col
								>
							</b-row>
							<b-row class="mt-3">
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.allowCandidateRemarks"
										:disabled="disableAll"
									>
										Allow Candidate Feedback
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.allowAgent"
										@change="
											selectdosanddonts(configData.allowAgent, 'allowAgent')
										"
										:disabled="disableAll"
									>
										Allow Agent
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.includeTimeNotifics"
										:disabled="disableAll"
									>
										Include Time Sensitivity Notifications
									</b-form-checkbox></b-col
								>
							</b-row>
							<b-row class="mt-3">
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.allowImageAndIdCapture"
										@change="
											selectdosanddonts(
												configData.allowImageAndIdCapture,
												'allowImageAndIdCapture'
											)
										"
										:disabled="disableAll"
									>
										Allow Image And ID Capture
									</b-form-checkbox></b-col
								>
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.allowExtension"
										@change="
											selectdosanddonts(
												configData.allowExtension,
												'allowExtension'
											)
										"
										:disabled="disableAll"
									>
										Allow Extension
									</b-form-checkbox></b-col
								>

								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.instantemail"
										@change="
											selectdosanddonts(configData.instantemail, 'instantemail')
										"
										:disabled="disableAll"
									>
										Instant Test Result
									</b-form-checkbox></b-col
								>

								<b-col cols="4"></b-col>
							</b-row>
							<b-row class="mt-3">
								<b-col cols="4"
									><b-form-checkbox
										class="testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="configData.allowLocation"
										:disabled="disableAll"
									>
										Allow Location
									</b-form-checkbox></b-col
								>
							</b-row>
						</div>
						<div class="d-flex justify-content-between py-2 px-4">
							<div
								class="font-mont fw-600 fs-14 color-696969 text-underline pointer mt-2"
								@click="loadExistingConfigs"
							>
								Select from existing
							</div>
							<div class="d-flex align-items-center gap-4">
								<b-button class="new-cancelBtn mt-1" @click="cancel"
									>Cancel</b-button
								>
								<b-button class="new-addBtn mt-1" @click="goNext(3)"
									>Next</b-button
								>
							</div>
						</div>
					</b-tab>
					<b-tab title="Do's and Dont's">
						<div class="addcon-tab-line" style="left: 710px;"></div>
						<div class="addcon-modal-scroll addcon-border-bottom">
							<b-row>
								<b-col cols="12">
									<label>Do's and Dont's</label>
									<div class="font-mont fw-400 fs-12 color-344054">
										(Min 1 required) <span class="asterik">*</span>
									</div>
									<div
										v-for="(item, index) in configData.dosAndDonts"
										:key="index"
										class="d-flex align-items-center w-100 gap-2 mt-3"
									>
										<label>{{ index + 1 }}.</label>
										<TextArea
											:rows="1"
											:max-rows="2"
											style="width: 95%;"
											class="position-relative"
											v-model="item.value"
											:value="item.value"
											:validation="
												$v.configData.dosAndDonts.$each[index].$error ||
													!$v.configData.dosAndDonts.$each[index].value
														.maxLength
											"
											:validationMessage="
												!$v.configData.dosAndDonts.$each[index].value.maxLength
													? 'Should not exceed 256 characters'
													: 'Required'
											"
											@input="updateDosDonts($event, index)"
											:disabled="disableAll"
										/>
										<img
											:class="item.value ? 'pointer' : 'opac-5'"
											src="../../assets/common-icons/addDosnDont.svg"
											alt="Add item"
											@click="addDosDontsItem"
											v-if="
												index === configData.dosAndDonts.length - 1 &&
													!disableAll
											"
										/>
										<img
											v-else-if="
												index !== configData.dosAndDonts.length - 1 &&
													!disableAll
											"
											class="pointer"
											src="../../assets/deleteicon.svg"
											alt="Remove item"
											@click="removeDosDontsItem(index)"
										/>
									</div>
								</b-col>
							</b-row>
						</div>
						<div class="d-flex justify-content-between py-2 px-4">
							<div
								class="font-mont fw-600 fs-14 color-696969 text-underline pointer mt-2"
								@click="loadExistingConfigs"
							>
								Select from existing
							</div>
							<div class="d-flex align-items-center gap-4">
								<b-button
									class="new-cancelBtn mt-1"
									v-if="!viewConfigID"
									@click="cancel"
									>Cancel</b-button
								>
								<b-button
									:disabled="loader"
									class="new-addBtn mt-1"
									@click="saveConfig(false)"
									>{{ buttonText }}</b-button
								>
							</div>
						</div>
					</b-tab>
				</b-tabs>
			</div>
		</b-modal>
		<b-modal
			id="confirm-edit"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('confirm-edit')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to edit ?</span>
			</div>
			<div class="mt-2 caution-modal-text">
				This configuration is tagged to more than one group. Do you want to
				create a new configuration or confirm the action?
			</div>
			<div class="mt-2 normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn mr-2" @click="saveConfig(true)"
					>Create New</b-button
				>
				<div class="sec-canceltext pointer" @click="confirm()">Confirm</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import InputComponent from "../../components/InputComponents/Input.vue";
import SingleSelect from "../../components/InputComponents/SingleSelect.vue";
import QuillEditor from "../../components/forms/quillEditor.vue";
import DateField from "../../components/InputComponents/DateField.vue";
import RadioSelect from "../../components/InputComponents/RadioSelect.vue";
import TextArea from "../../components/InputComponents/TextArea.vue";
import toast from "@/views/mixin/toast";
import {
	required,
	helpers,
	maxLength,
	numeric,
	between,
	requiredIf,
} from "vuelidate/lib/validators";
import {
	addConfig,
	getConfig,
	editConfig,
	dosanddontslist,
} from "@/utils/apiFunctions";

export default {
	props: {
		showModal: Boolean,
		testID: String,
		groupID: String,
		editConfigID: String,
		viewConfigID: String,
	},
	components: {
		InputComponent,
		SingleSelect,
		QuillEditor,
		DateField,
		RadioSelect,
		TextArea,
	},
	mixins: [toast],
	validations: {
		configData: {
			//opening screen display tab validations
			name: { required, maxLength: maxLength(128) },
			testOrg: { required, maxLength: maxLength(128) },
			testDesc: { required, maxLength: maxLength(100024) },

			//question behaviour tab validations
			openTestdt: {
				required,
			},
			closeTestdt: {
				required,
			},
			passingPercentage: {
				required,
				numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
				between: between(1, 100),
			},
			quesPerScreen: {
				required,
				between: between(1, 10),
				numeric,
			},
			testDuration: {
				required,
				between: between(5, 360),
				alpha: helpers.regex("alpha", /^\d{1,4}\.?\d{0,2}$/i),
			},
			negativeMarkValue: {
				required,
				between: between(0, 30),
				numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
			},
			maxnoattempts: {
				required,
				between: between(1, 10),
				numeric,
			},
			buffertime: {
				required,
				between: between(0, 60),
				numeric: helpers.regex("numeric", /^[1-9][0-9]?$|^60$/),
			},
			timebnvalue: {
				required: requiredIf(function() {
					return (
						this.configData.maxnoattempts >= 2 &&
						this.configData.timebnsel != ""
					);
				}),
				numeric: helpers.regex("numeric", /^\d{1,3}$/),
				between: between(1, 60),
			},
			timebnsel: {
				required: requiredIf(function() {
					return this.configData.maxnoattempts >= 2;
				}),
			},

			//system setup tab validations
			communicationTestAttempts: {
				requiredIfCommunicationTest: helpers.withParams(
					{ type: "requiredIfCommunicationTest" },
					(value, vm) => {
						if (vm.communicationTest) {
							return required(value);
						}
						return true;
					}
				),
				numeric,
				between: between(1, 5),
			},
			screenCapture: {
				required: helpers.withParams(
					{ type: "requiredIfScreenCapture" },
					(value, vm) => {
						if (vm.enableProctoring) {
							return required(value);
						}
						return true;
					}
				),
				numeric,
				between: between(1, 15),
			},

			//dos and donts tab validations
			dosAndDonts: {
				$each: {
					value: {
						required,
						maxLength: maxLength(256),
					},
				},
			},
		},
	},
	computed: {
		checkSecondTabError() {
			const secondTabError =
				this.$v.configData.openTestdt.$error ||
				this.$v.configData.closeTestdt.$error ||
				this.$v.configData.passingPercentage.$error ||
				this.$v.configData.quesPerScreen.$error ||
				this.$v.configData.testDuration.$error ||
				this.$v.configData.negativeMarkValue.$error ||
				this.$v.configData.maxnoattempts.$error ||
				this.$v.configData.buffertime.$error ||
				this.$v.configData.timebnsel.$error ||
				this.$v.configData.timebnvalue.$error;
			return secondTabError || this.timeDiffMinutes;
		},
		checkThirdTabError() {
			const thirdTabError =
				this.$v.configData.communicationTestAttempts.$error ||
				this.$v.configData.screenCapture.$error ||
				(this.configData.enableProctoring && !this.configData.enableCamera);

			return thirdTabError;
		},

		checkFourthTabError() {
			const fourthTabError =
				this.$v.configData.dosAndDonts.$error ||
				this.$v.configData.dosAndDonts.$each.$error;
			return fourthTabError;
		},

		timeDiffMinutes() {
			if (this.configData.openTestdt && this.configData.closeTestdt) {
				const startDate = new Date(this.configData.openTestdt);
				const endDate = new Date(this.configData.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.configData.testDuration !== null) {
					return (
						this.configData.testDuration > Math.floor(timeDiff / (1000 * 60))
					);
				}
				return false;
			}
			return null;
		},

		hoursDiffAttempts() {
			if (this.configData.openTestdt && this.configData.closeTestdt) {
				const startDate = new Date(this.configData.openTestdt);
				const endDate = new Date(this.configData.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.configData.testDuration !== null) {
					const hoursDiff = timeDiff / (1000 * 60 * 60);
					return hoursDiff > 24;
				}
				return false;
			}

			return null;
		},
		minutesDiffAttempts() {
			if (this.configData.openTestdt && this.configData.closeTestdt) {
				const startDate = new Date(this.configData.openTestdt);
				const endDate = new Date(this.configData.closeTestdt);
				const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
				const timeDiffInHours = timeDiffInMilliseconds / (1000 * 60 * 60);

				if (this.configData.testDuration !== null) {
					return timeDiffInHours > 1;
				}
				return false;
			}

			return null;
		},
		filteredTimeOptions() {
			const showHours = this.minutesDiffAttempts;
			const showDays = this.hoursDiffAttempts;
			console.log(
				"now the filtered	time options are",
				this.timeBetweenOptions.filter(
					(option) =>
						(option.value !== "hrs" || showHours) &&
						(option.value !== "days" || showDays)
				)
			);
			return this.timeBetweenOptions.filter(
				(option) =>
					(option.value !== "hrs" || showHours) &&
					(option.value !== "days" || showDays)
			);
		},
	},
	created() {
		if (this.editConfigID) this.loadExistingConfig(this.editConfigID);
		if (this.viewConfigID) this.viewConfig(this.viewConfigID);
		this.getdosanddonts();
	},
	data() {
		return {
			timeoptions: [
				{
					value: "hrs",
					text: "Hours",
				},
				{
					value: "mins",
					text: "Minutes",
				},
				{
					value: "days",
					text: "Days",
				},
			],
			timeValidationError: false,
			defaultdosanddonts: [],
			configType: "Add",
			disableAll: false,
			check: true,
			buttonText: "Save & Create",
			loader: false,
			tabIndex: 0,
			configData: {
				name: "",
				testOrg: "",
				testDesc: "",
				testInst: "",
				timebnsel: "",
				timebnvalue: "",
				dispDuration: true,
				dispCount: true,
				allowCandidateRemarks: false,
				quesPerScreen: "10",
				priority: "first",
				shuffle: false,
				dispReqStatus: false,
				displayReqFirst: false,
				dispMarks: false,
				test: { value: "private", text: "Private" },
				allowAgent: false,
				payment: false,
				allowImageAndIdCapture: false,
				allowExtension: false,
				allowLocation: false,
				enableScreenShare: false,
				negativeMarkValue: null,
				openTestdt: "",
				closeTestdt: "",
				passingPercentage: "",
				testDuration: 30,
				typingTest: false,
				enableProctoring: false,
				communicationTest: false,
				communicationTestDuration: 45,
				communicationTestAttempts: null,
				typingDuration: 60,
				includeTimeNotifics: false,
				enableCamera: false,
				includeEndTest: true,
				instantemail: false,
				internetCheck: false,
				maxnoattempts: 1,
				buffertime: null,
				timebetweenattempts: "",
				screenCapture: null,
				curDate: "",
				paymentDetails: {
					cost: null,
					certificate: false,
					training: false,
					badge: false,
					toLearn: "",
					skillsGain: "",
					about: "",
				},
				dosAndDonts: [{ value: "" }],
			},
			testTypeOptions: [
				{ value: "private", text: "Private" },
				{ value: "public", text: "Public" },
			],
			timeBetweenOptions: [
				{ value: "mins", text: "Minute" },
				{ value: "hrs", text: "Hours" },
				{ value: "days", text: "Days" },
			],
			priorityOptions: [
				{ value: "first", text: "First Attempt" },
				{ value: "last", text: "Last Attempt" },
				{ value: "highestScored", text: "Highest Score" },
			],
			dirtyCheckdesc: true,
		};
	},
	methods: {
		onTimeBnSelChange(selected) {
			selected =
				selected == "mins"
					? { value: "mins", text: "Minute" }
					: selected == "hrs"
					? { value: "hrs", text: "Hours" }
					: selected == "days"
					? { value: "days", text: "Days" }
					: "";
			this.$set(this.configData, "timebnsel", selected);
			this.$v.configData.timebnsel.$touch();
		},
		resetProctoring() {
			if (!this.configData.enableProctoring) {
				this.configData.screenCapture = null;
			}
			if (!this.configData.communicationTest) {
				this.configData.communicationTestAttempts = null;
			}
		},
		async getdosanddonts() {
			try {
				const res = await dosanddontslist();
				if (res.status == 200) {
					let data = res.data.data;
					for (let i in data) {
						if (data[i].type == "Dos and Donts") {
							this.defaultdosanddonts = data[i].codeList;
						}
					}
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		selectdosanddonts(value, id) {
			if (value) {
				if (
					this.configData.dosAndDonts.length > 0 &&
					this.configData.dosAndDonts[0].value == ""
				) {
					this.configData.dosAndDonts.splice(0, 1);
				}

				const defaultDosAndDonts = this.defaultdosanddonts.filter(
					(item) => item.value === id
				);
				defaultDosAndDonts.forEach((item) => {
					this.configData.dosAndDonts.push({
						value: item.description,
						code: item.value,
					});
				});
			} else {
				const filteredDosAndDonts = this.configData.dosAndDonts.filter(
					(item) => item.code !== id
				);
				this.configData.dosAndDonts =
					filteredDosAndDonts.length > 0
						? filteredDosAndDonts
						: [{ value: "", code: "" }];
			}
		},
		viewConfig(id) {
			this.disableAll = true;
			this.loadExistingConfig(id);
		},
		async loadExistingConfig(id) {
			console.log("the id is akjhgsyv", id);
			const response = await getConfig(id);
			if (response.status == 200) {
				this.buttonText = this.viewConfigID ? "Close" : "Update";
				this.configType = this.viewConfigID ? "View" : "Edit";
				console.log("the response is", response);
				Object.assign(this.configData, response.data.data.config);
				this.configData.timebnsel =
					this.configData.timebnsel == "mins"
						? { value: "mins", text: "Minute" }
						: this.configData.timebnsel == "hrs"
						? { value: "hrs", text: "Hours" }
						: this.configData.timebnsel == "days"
						? { value: "days", text: "Days" }
						: "";
				this.configData.name = response.data.data.configName;
				this.configData.test = this.getTestValue(
					response.data.data.config.test
				);
			}
		},
		getTestValue(val) {
			if (val == "private") {
				return { value: "private", text: "Private" };
			} else if (val == "public") {
				return { value: "public", text: "Public" };
			}
		},
		updateDateTime(type, val) {
			console.log("the value is", val);
			this.configData[type + "Testdt"] = val;
			console.log(
				"the updated value is for key",
				type + "Testdt",
				this.configData[type + "Testdt"]
			);
		},
		changeMaxAttempts() {
			if (this.configData.maxnoattempts < 2) {
				this.configData.timebetweenattempts = null;
				this.configData.timebnvalue = "";
				this.configData.timebnsel = "";
				this.$v.configData.timebnsel.$touch();
			}
		},
		updateDosDonts(val, index) {
			this.configData.dosAndDonts[index].value = val;
		},
		updateTestDesc(val) {
			this.configData.testDesc = val;
		},
		goNext(index) {
			const fieldsToValidateByTab = {
				1: ["testDesc", "testOrg", "name"],
				2: [
					"openTestdt",
					"closeTestdt",
					"passingPercentage",
					"quesPerScreen",
					"priority",
					"negativeMarkValue",
					"maxnoattempts",
					"buffertime",
					"timebnvalue",
				],
				3: ["maxnoattempts", "communicationTestAttempts", "screenCapture"],
			};

			const fields = fieldsToValidateByTab[index];

			if (fields && fields.length) {
				let isInvalid = false;

				fields.forEach((field) => {
					const validationField = this.$v.configData[field];
					if (validationField) {
						validationField.$touch();
						if (validationField.$invalid) {
							isInvalid = true;
						}
					}
				});
				if (index === 2 && this.timeDiffMinutes) {
					return;
				}
				if (isInvalid) {
					return;
				}
			}

			if (index === 3 && this.configData.enableProctoring) {
				if (!this.configData.enableCamera) {
					return;
				}
			}

			this.tabIndex = index;
		},
		validateText(val) {
			console.log("the value is", val);
			this.dirtyCheckdesc = val;
		},
		addDosDontsItem() {
			if (this.configData.dosAndDonts.length > 0) {
				if (
					this.configData.dosAndDonts[this.configData.dosAndDonts.length - 1]
						.value === ""
				) {
					return;
				}
			}
			this.configData.dosAndDonts.push({ value: "" });
		},
		removeDosDontsItem(index) {
			if (this.configData.dosAndDonts.length > 1) {
				this.configData.dosAndDonts.splice(index, 1);
			}
		},
		loadExistingConfigs() {
			// Implement logic to load existing configurations
			console.log("Loading existing configurations...");
			this.$emit("close-modal");
		},
		cancel() {
			this.resetForm();
			this.$emit("close-modal");
		},

		confirm() {
			this.check = false;
			this.saveConfig();
		},
		async saveConfig(newConfig = false) {
			if (this.viewConfigID) {
				this.$emit("close-modal");
				return;
			}
			try {
				this.$v.$touch();
				this.$v.configData.$touch();
				if (!this.validateForm()) {
					this.errorToast("Please fill all required fields");
					return;
				}
				this.loader = true;

				if (
					this.configData.timebnsel !== "" &&
					this.configData.timebnsel !== null
				) {
					if (this.configData.timebnsel.value == "hrs") {
						this.configData.timebetweenattempts =
							this.configData.timebnvalue * 60;
					} else if (this.configData.timebnsel.value == "mins") {
						this.configData.timebetweenattempts = this.configData.timebnvalue;
					} else if (this.configData.timebnsel.value == "days") {
						this.configData.timebetweenattempts =
							this.configData.timebnvalue * 1440;
					}
				}
				let payload = {
					portion: "Config",
					name: this.configData.name,
					config: {
						...this.configData,
						test: this.configData.test?.value,
						timebnsel: this.configData.timebnsel?.value,
					},
				};

				payload.config.curDate = new Date().toISOString();
				console.log("this.editConfigID", this.editConfigID, newConfig);
				if (this.editConfigID && !newConfig) {
					payload.configID = this.editConfigID;
					payload.check = this.check;
					const res = await editConfig(payload);
					if (res.status == 200) {
						this.successToast("Configuration updated successfully");
						this.$emit("close-modal");
						this.$emit("update-config");
					} else if (res.status == 409) {
						this.$bvModal.show("confirm-edit");
					}
				} else {
					const res = await addConfig(payload);
					if (res.status == 200) {
						this.successToast("Configuration added successfully");
						setTimeout(() => {
							this.$emit("close-modal");
							this.$emit("change-selected-config", res.data.data.ConfigID);
						}, 1000);
					} else if (res.status == 409) {
						this.errorToast("Config name already exists");
						this.$bvModal.hide("confirm-edit");
					}
				}
				console.log("payload", JSON.stringify(payload));
			} catch (err) {
				console.log("the error is ", err);
			} finally {
				this.loader = false;
			}
		},
		validateForm() {
			if (this.timeDiffMinutes) return false;
			const requiredFields = [
				"name",
				"testOrg",
				"testDesc",
				"openTestdt",
				"closeTestdt",
				"passingPercentage",
				"negativeMarkValue",
				"maxnoattempts",
				"buffertime",
				"timebnvalue",
				"timebnsel",
				"quesPerScreen",
				"screenCapture",
				"communicationTestAttempts",
				"testDuration",
				"dosAndDonts",
			];

			return requiredFields.every((field) => {
				const validationField = this.$v.configData[field];
				if (validationField) {
					validationField.$touch();
					return !validationField.$invalid;
				}
				return true;
			});
		},
		resetForm() {
			this.configData = {
				name: "",
				testOrg: "",
				testDesc: "",
				testInst: "",
				timebnsel: "",
				timebnvalue: "",
				dispDuration: true,
				dispCount: true,
				allowCandidateRemarks: false,
				quesPerScreen: "10",
				priority: "first",
				shuffle: false,
				dispReqStatus: false,
				displayReqFirst: false,
				dispMarks: false,
				test: "private",
				allowAgent: false,
				payment: false,
				allowImageAndIdCapture: false,
				allowExtension: false,
				allowLocation: false,
				enableScreenShare: false,
				negativeMarkValue: "0",
				openTestdt: "",
				closeTestdt: "",
				passingPercentage: "",
				testDuration: 30,
				typingTest: false,
				enableProctoring: false,
				communicationTest: false,
				communicationTestDuration: 45,
				communicationTestAttempts: null,
				typingDuration: 60,
				includeTimeNotifics: false,
				enableCamera: false,
				includeEndTest: true,
				instantemail: false,
				maxnoattempts: 1,
				buffertime: "10",
				timebetweenattempts: "",
				screenCapture: null,
				curDate: "",
				paymentDetails: {
					cost: null,
					certificate: false,
					training: false,
					badge: false,
					toLearn: "",
					skillsGain: "",
					about: "",
				},
				dosAndDonts: [{ value: "" }],
			};
			this.tabIndex = 0;
		},
	},
	watch: {
		showModal(newVal) {
			if (!newVal) {
				this.resetForm();
			}
		},
		editConfigID(newVal) {
			if (newVal) {
				this.disableAll = false;
				this.loadExistingConfig(newVal);
			}
		},
	},
};
</script>

<style lang="scss">
#addConfigModal {
	.modal-dialog {
		max-width: 1213px;
	}

	.modal-body {
		padding: 0;
	}
}
.addcon-border-bottom {
	border-bottom: 1px solid #e4e7ec;
}
header.head {
	padding: 12px 20px;
}

.dynamic-modal-tabs {
	width: 100%;
	padding: 2px;
	height: 45px;
}

.dynamic-modal-tabs ul {
	width: 100%;
}

.dynamic-modal-tabs ul li {
	width: 235px;
	position: relative;
}

.dynamic-modal-tabs .nav-tabs .nav-link {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #595959;
	width: 100%;
	text-align: center;
}

.dynamic-modal-tabs .nav-tabs .nav-link.active,
.dynamic-modal-tabs .nav-tabs .nav-item.show .nav-link {
	color: #72738e !important;
	border-radius: 8px;
	border-color: transparent;
	background-color: transparent;
}

.dynamic-modal-tabs .nav-tabs .nav-link:hover,
.dynamic-modal-tabs .nav-tabs .nav-link:focus {
	border-color: transparent;
}

.dynamic-modal-tabs .nav-tabs .nav-link.disabled,
.dynamic-modal-tabs .nav-tabs .nav-link:disabled {
	opacity: 0.5;
}

.addcon-tab-line {
	background: #72738e;
	box-shadow: 0px 4px 8px 0px #0000002b;
	height: 4px;
	width: 228px;
	border-radius: 8px;
	position: absolute;
	left: 0px;
	top: 93px;
}

.addcon-tabs-height {
	height: calc(100vh - 255px);
	max-height: 800px;
}
.addcon-modal-scroll {
	height: calc(100vh - 360px);
	max-height: 695px;
	overflow: auto;
	padding: 20px 32px 20px 50px;
}

.addcon-tabs-height .new-addBtn.btn-secondary {
	min-width: 87px;
}
.addcon-tabs-height .new-cancelBtn.btn-secondary {
	min-width: 87px;
}

.addcon-tabs-height .row {
	display: flex;
	flex-wrap: wrap;
	margin-right: 0;
	margin-left: 0;
}

#addConfigModal label {
	font-weight: 500;
}
</style>
